"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Calendar = _interopRequireDefault(require("./Calendar"));

var _YearPicker = _interopRequireDefault(require("./YearPicker"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var leftCaret = /*#__PURE__*/_react["default"].createElement("svg", {
  fill: "currentColor",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}));

var rightCaret = /*#__PURE__*/_react["default"].createElement("svg", {
  fill: "currentColor",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}));

var downCaret = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M7.5 10L12.5 15L17.5 10H7.5Z",
  fill: "currentColor"
}));

var DxcDatePicker = function DxcDatePicker(_ref) {
  var date = _ref.date,
      onDateSelect = _ref.onDateSelect,
      id = _ref.id;

  var _useState = (0, _react.useState)(date.isValid() ? date : (0, _dayjs["default"])()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      innerDate = _useState2[0],
      setInnerDate = _useState2[1];

  var _useState3 = (0, _react.useState)("calendar"),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      content = _useState4[0],
      setContent = _useState4[1];

  var selectedDate = date.isValid() ? date : null;
  var translatedLabels = (0, _useTranslatedLabels["default"])();

  var handleDateSelect = function handleDateSelect(date) {
    setInnerDate(date);
    onDateSelect(date);
  };

  var handleOnYearSelect = function handleOnYearSelect(year) {
    setInnerDate(innerDate.set("year", year));
    setContent("calendar");
  };

  var handleMonthChange = function handleMonthChange(date) {
    setInnerDate(date);
  };

  return /*#__PURE__*/_react["default"].createElement(DatePicker, {
    id: id
  }, /*#__PURE__*/_react["default"].createElement(PickerHeader, null, /*#__PURE__*/_react["default"].createElement(HeaderButton, {
    "aria-label": translatedLabels.calendar.previousMonthTitle,
    title: translatedLabels.calendar.previousMonthTitle,
    onClick: function onClick() {
      return handleMonthChange(innerDate.set("month", innerDate.get("month") - 1));
    }
  }, leftCaret), /*#__PURE__*/_react["default"].createElement(HeaderYearTrigger, {
    "aria-live": "polite",
    onClick: function onClick() {
      return setContent(function (content) {
        return content === "yearPicker" ? "calendar" : "yearPicker";
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(HeaderYearTriggerLabel, null, translatedLabels.calendar.months[innerDate.get("month")], " ", innerDate.format("YYYY")), downCaret), /*#__PURE__*/_react["default"].createElement(HeaderButton, {
    "aria-label": translatedLabels.calendar.nextMonthTitle,
    title: translatedLabels.calendar.nextMonthTitle,
    onClick: function onClick() {
      return handleMonthChange(innerDate.set("month", innerDate.get("month") + 1));
    }
  }, rightCaret)), content === "calendar" && /*#__PURE__*/_react["default"].createElement(_Calendar["default"], {
    innerDate: innerDate,
    selectedDate: selectedDate,
    onInnerDateChange: setInnerDate,
    onDaySelect: handleDateSelect
  }), content === "yearPicker" && /*#__PURE__*/_react["default"].createElement(_YearPicker["default"], {
    selectedDate: selectedDate,
    onYearSelect: handleOnYearSelect
  }));
};

var DatePicker = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  padding-top: 16px;\n  background-color: ", ";\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  border: 1px solid #bfbfbf;\n  border-radius: 4px;\n"])), function (props) {
  return props.theme.dateInput.pickerBackgroundColor;
});

var PickerHeader = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 16px;\n"])));

var HeaderButton = _styledComponents["default"].button(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0px;\n  background-color: ", ";\n  font-size: 1.5rem;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n\n  &:focus {\n    outline: ", " solid 2px;\n  }\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: #4b1c7d;\n    color: #ffffff;\n  }\n  svg {\n    display: inline-block;\n    flex-shrink: 0;\n    width: 1em;\n    height: 1em;\n    font-size: 1.5rem;\n    user-select: none;\n  }\n"])), function (props) {
  return props.theme.dateInput.pickerMonthArrowsBackgroundColor;
}, function (props) {
  return props.theme.dateInput.pickerFocusColor;
}, function (props) {
  return props.theme.dateInput.pickerHoverDateBackgroundColor;
});

var HeaderYearTrigger = _styledComponents["default"].button(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  width: 172px;\n  color: ", ";\n  background-color: transparent;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n  }\n  &:focus {\n    outline: ", " solid 2px;\n  }\n  &:active {\n    color: #ffffff;\n    background-color: #4b1c7d;\n  }\n"])), function (props) {
  return props.theme.dateInput.pickerMonthFontColor;
}, function (props) {
  return props.theme.dateInput.pickerHoverDateBackgroundColor;
}, function (props) {
  return props.theme.dateInput.pickerFocusColor;
});

var HeaderYearTriggerLabel = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: ", ";\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 19px;\n"])), function (props) {
  return props.theme.dateInput.pickerFontFamily;
});

var _default = /*#__PURE__*/_react["default"].memo(DxcDatePicker);

exports["default"] = _default;